import { getJSON, getHrefParam, PASSPORT_HOST } from '../ultile';
import { TOST } from '../dialog';
import { encryption } from '../../utiles';
import globalConfig from '../../utiles/globalConfig';
import languages from '../languages';
import {
  getVerrifyCodeValidate,
  changePwdValite,
  upgradeValite,
  safeQuessionValite,
  profileValidate,
  bindEmailValidate,
  CHECKED_VAL
} from '../validator';
import {
  RESET_EMAIL,
  CHANGE_USER_INFO,
  CHANGE_IS_BIND_EMAIL
} from '../account';
export const GET_VERIFFY_CODE = 'sendVerrifyCodeToEmail';
export const CHANGE_PWD = 'changePassword';
export const UPGRADE = 'upgrade';
export const LOAD_SAFE_QEUSSION = 'loadSafeQuession';
export const SET_QUESSION = 'setQuession';
export const LOAD_EXTEND_INFO = 'loadUsrExtendInfo';
export const LOAD_USER_INFO = 'loadUserInfo';
export const SET_ORIGIN_USER_TYPE_ACTION = 'setOriginUserTypeAction';
export const MALE = 0;
export const FEMALE = 1;
export const SET_USR_EXT_INFO = 'setUserExtendInfo';
export const SET_USR_EXT_INFO_VGM = 'setUserExtendInfoVgm';
export const BIND_EMAIL = 'bindEmail';
export const SEND_VGM_CODE = 'sendVgmCode';
export const EMPTY_QUESSIONS = 'emptyQuession';
export const VERIFY_EMAIL = 'verifyEmail';
export const VALIDATE_SECURITY_QUESSION = 'validateSEcurityQuession';
export const SET_ORIGIN_USER_TYPE = 'setOriginUserType';
export const SWITCH_PASSPORT_LANG = 'switch_passport_lang';

export const VARIFY_EMAIL_REF = 'verify_email';
export const BIND_EMAIL_REF = 'bind_email';
export const UPDATE_EMAIL_REF = 'update_email';
let roleName = getHrefParam('roleName');
let userName = getHrefParam('userName');
const SET_MY_QUESSION = 'setMyquession';
const CHANGE_EXTEN_INFO = 'changeExtendInfo';

const EMAIL_VARRIFY_ACTION = PASSPORT_HOST + 'center/ajax/send_eck';
const CHANGE_PWD_ACTION = PASSPORT_HOST + 'center/changePwd';
const UPGRADE_ACTION = PASSPORT_HOST + 'register/bind';
const LOAD_SAFE_QUESSION_ACTION = PASSPORT_HOST + 'center/ajax/get_question';
const SET_SAFE_QUESSION_ACTION = PASSPORT_HOST + 'center/security/setQuestion';
const LOAD_USER_INFO_ACTION = PASSPORT_HOST + 'center/ajax/get_user_json';
const LOAD_EXTEND_INFO_ACTION =
  PASSPORT_HOST + 'center/ajax/get_user_info_json';
const SET_EXT_INFO_ACTION = PASSPORT_HOST + 'center/userInfo';
const SET_EMAIL_TOKEN = 'setEmailToken';
const BIND_EMAIL_ACTION = PASSPORT_HOST + 'center/bindEmail';
const SEND_VGM_CODE_ACTION = PASSPORT_HOST + 'center/user_info/send_vgm_code';
const VERIFY_EMAIL_ACTION = PASSPORT_HOST + 'center/bind_email/verify';
const VALIDATE_SECURITY_ACTION =
  PASSPORT_HOST + 'center/security/checkSecurityQuestion';

const NUM = 'num';
const ANSWER = 'answer';
export const SET_RESET_QUESSION_TOKEN = 'resetQuessionToken';
export const FIND_PWD_REF = 'find_password';
export const CHANGE_QUESSION_REF = 'change_question';
export const REFRESH_USER_JSON = 'refresh_user_json';
const REFRESH_USER_JSON_ACTION =
  PASSPORT_HOST + 'center/ajax/refresh_user_json';

languages.init();
let mapQuession = function (quessionsResponse) {
  let quessions = [];
  /* eslint-disable no-unused-vars */
  for (let id in quessionsResponse) {
    let quession = {
      id: id,
      disabled: false,
      text: quessionsResponse[id]
    };
    quessions.push(quession);
  }
  return [
    {
      id: '',
      disabled: true,
      text: languages.get('slectQuessionTips')
    }
  ].concat(quessions);
};

let mapQuessionGroups = function (quesisonGroupResponse) {
  let quessionGroups = [];
  /* eslint-disable  no-unused-vars */
  for (let groupId in quesisonGroupResponse) {
    let quessionGroup = mapQuession(quesisonGroupResponse[groupId]);
    quessionGroups.push(quessionGroup);
  }
  return quessionGroups;
};

let mapAnswerKeyToPost = function (answers) {
  var mapRes = {};
  for (let i = 0, len = answers.length; i < len; i++) {
    let answerKey = ANSWER + (i + 1);
    let numberKey = NUM + (i + 1);
    mapRes[answerKey] = answers[i].answer;
    mapRes[numberKey] = answers[i].id;
  }
  return mapRes;
};

let extInfoMap = function (extendInfoMap) {
  var res = {};
  res.realName = extendInfoMap['REAL_NAME'];
  res.sex = parseInt(extendInfoMap['SEX']);
  res.birthday = extendInfoMap['BIRTHDAY'];
  res.email = extendInfoMap['EMAIL'] || '';
  res.phoneCode = extendInfoMap['PHONE_CODE'];
  res.phone = extendInfoMap['PHONE'];
  res.id_card_country = extendInfoMap['ID_CARD_COUNTRY'];
  res.id_card_number = extendInfoMap['ID_CARD_NUMBER'];
  res.id_card_issue_date = extendInfoMap['ID_CARD_ISSUE_DATE'] || '';
  res.facebook = extendInfoMap['FB_ACCOUNT'];
  res.imType = extendInfoMap['IM_TYPE'];
  res.id_card_issue_region = extendInfoMap['ID_CARD_ISSUE_REGION'] || '';
  res.address = extendInfoMap['ADDRESS'] || '';
  res.isKr = extendInfoMap['IS_KR'] || '';
  res.isVgm = extendInfoMap['IS_VGM'] || '';
  res.imAccount = extendInfoMap['IM_ACCOUNT'];
  res.bbsId = extendInfoMap['BBS_ID'];
  res.bbsName = extendInfoMap['BBS_NAME'];
  res.completion = extendInfoMap['INFO_COMPLETION'];
  return res;
};

// let userInfoMap = function (userInfoMap) {
//   var res = {};
//   res.uid = userInfoMap['UID'];
//   res.loginAccount = parseInt(userInfoMap['LOGIN_ACCOUNT']);
//   res.displayName = userInfoMap['DISPLAY_NAME'];
//   // 0:平台账号 1:facebook 2:google 3:game center 4:游客 5:推特 6:line 7:naver
//   res.originUserType = userInfoMap['ORIGIN_USER_TYPE'];
//   res.valid = userInfoMap['VALID'];
//   res.registerTime = userInfoMap['REGISTER_TIME'];
//   res.registerIp = userInfoMap['REGISTER_IP'];
//   res.Id = userInfoMap['ID'];
//   res.isBindFb = userInfoMap['IS_BIND_FB'];
//   res.fbName = userInfoMap['FB_NAME'];
//   res.isBindGc = userInfoMap['IS_BIND_GC'];
//   res.gcName = userInfoMap['GC_NAME'];
//   res.isBindGp = userInfoMap['IS_BIND_GP'];
//   res.gpName = userInfoMap['GP_NAME'];
//   res.isBindTw = userInfoMap['IS_BIND_TW'];
//   res.twName = userInfoMap['TW_NAME'];
//   res.isUpgrade = userInfoMap['IS_UPGRADE'];
//   res.upgradeName = userInfoMap['UPGRADE_NAME'];
//   return res;
// };
const initLanguage = () => {
  return languages.mapMutiples([
    'feedback',
    'feedbackTips',
    'cancel',
    'confirm',
    'switch',
    'bind',
    'terms',
    'tips',
    'bindTps',
    'accountSetting',
    'upgrade',
    'profile',
    'bindEmail',
    'changePassword',
    'securityQuestion',
    'and',
    'haveAgree',
    'termsOfUse',
    'privacyPolicy',
    'accountName',
    'password',
    'newPwd',
    'repeatPassword',
    'completeness',
    'completeTips',
    'realName',
    'gender',
    'male',
    'female',
    'birthday',
    'phone',
    'region',
    'ID',
    'bindEmailTips',
    'enterEmail',
    'enterEmailTips',
    'enterEmailVrfcationTips',
    'originPwd',
    'newPwd',
    'securityQuestionTips',
    'slectQuessionTips',
    'submit',
    'send',
    'answerTips',
    'changePwdSuccess',
    'modify',
    'rebindEmail',
    'bindEmailSuccess',
    'reSetSecurityQuessoon',
    'guestSwitchTips',
    'canotModifyTips',
    'rebindEmailTips',
    'reGetVrfCode',
    'findPwd',
    'findPwdTips',
    'editVrfCodeTips',
    'findPwdWayTips',
    'emailWay',
    'emailWayTips',
    'quessionWay',
    'quessionWayTips',
    'resetPwdBtn',
    'lastStep',
    'validateQuessionTips',
    'sendEmailTips',
    'setNewPwdTips',
    'findPwdFailTips',
    'exchange',
    'countryCode',
    'deleteaccount_title2',
    'deleteaccount_step1_1',
    'deleteaccount_step1_2',
    'deleteaccount_step1_3',
    'deleteaccount_step1_4',
    'deleteaccount_step2_1',
    'deleteaccount_step2_2',
    'deleteaccount_step3',
    'deleteaccount_step3_1',
    'deleteaccount_step3_2',
    'applyForAccountFix',
    'applyFixAccount',
    'findPwdByFixAccount',
    'accountFix',
    'SwitchWithThirdWay',
    'account_czsm1',
    'account_czsm2',
    'account_czsm3',
    'account_wzfdmm',
    'account_qzcsrmm',
    'account_fxyjm',
    'account_yjmsm1',
    'account_yjmsm2',
    'account_yjmsm3',
    'account_yjmsm4',
    'account_fz',
    'account_cxfx',
    'account_czsm4',
    'account_czsm5',
    'account_yjm',
    'account_yj',
    'login',
    'account_syyjm',
    'account_yjmznsyyc',
    'account_sryjm',
    'account_srmm',
    'account_delete_scdqzh',
    'account_delete_fwq',
    'account_delete_zhm',
    'account_delete_jshflj',
    'account_delete_qzyzmdxx',
    'account_delete_jtbcysxx',
    'contactService',
    'questionnaire_btn',
    'v3Completed'
  ]);
};

export default {
  state: {
    userName: userName,
    serverName: '',
    roleName,
    avatar: '',
    errMsg: '',
    showExchange: 0,
    quessionGroups: [
      [
        {
          id: '',
          disableOptions: true,
          text: 'Please select a security question?'
        }
      ]
    ],
    mapQuessions: [],
    realName: '',
    sex: MALE,
    birthday: '',
    email: '',
    phoneCode: '',
    phone: '',
    idCardType: '',
    idCard: '',
    imType: '',
    imAccount: '',
    bbsId: '',
    bbsName: '',
    completion: 0,
    emailToken: '',
    resetQuessionToken: '',
    originUserType: '0', // 0:平台账号 1:facebook 2:google 3:game center 4:游客 5:推特 6:line 7:naver
    accountLanguages: initLanguage(),
    accountLang: languages.getLanguage()
  },
  getters: {
    getAccountLanguages: state => state.accountLanguages,
    getAccountLang: state => state.accountLang
  },
  mutations: {
    [LOAD_SAFE_QEUSSION](state, quessionGgoups) {
      let quessionGroups = mapQuessionGroups(quessionGgoups);
      state.quessionGroups = quessionGroups;
    },
    [CHANGE_EXTEN_INFO](state, extendInfoMap) {
      state.realName = extendInfoMap['REAL_NAME'];
      state.sex = parseInt(extendInfoMap['SEX']);
      state.birthday = extendInfoMap['BIRTHDAY'];
      state.email = extendInfoMap['EMAIL'];
      state.phoneCode = extendInfoMap['PHONE_CODE'];
      state.phone = extendInfoMap['PHONE'];
      state.id_card_country = extendInfoMap['ID_CARD_COUNTRY'];
      state.id_card_number = extendInfoMap['ID_CARD_NUMBER'];
      state.facebook = extendInfoMap['FB_ACCOUNT'];
      state.imType = extendInfoMap['IM_TYPE'];
      state.imAccount = extendInfoMap['IM_ACCOUNT'];
      state.bbsId = extendInfoMap['BBS_ID'];
      state.bbsName = extendInfoMap['BBS_NAME'];
      state.completion = extendInfoMap['INFO_COMPLETION'];
    },
    [SET_MY_QUESSION](state, myQuessions) {
      state.mapQuessions = [];
      for (var id in myQuessions) {
        state.mapQuessions.push({
          id: id,
          quession: myQuessions[id],
          answer: ''
        });
      }
    },
    [SET_EMAIL_TOKEN](state, token) {
      state.emailToken = token;
    },
    [EMPTY_QUESSIONS](state) {
      state.mapQuessions = [];
    },
    [SET_RESET_QUESSION_TOKEN](state, token) {
      state.resetQuessionToken = token;
    },
    [SET_ORIGIN_USER_TYPE](state, type) {
      state.originUserType = type;
    },
    [SWITCH_PASSPORT_LANG](state, payload) {
      languages.setLanguage(payload);
      state.accountLang = payload;
      state.accountLanguages = initLanguage();
    }
  },
  actions: {
    [VALIDATE_SECURITY_QUESSION](
      { commit, dispatch },
      { answers, ref, uname }
    ) {
      let answerMap = mapAnswerKeyToPost(answers);
      answerMap.ref = ref;
      if (FIND_PWD_REF == ref) {
        answerMap.uname = uname;
      }
      return new Promise((resolve, reject) => {
        getJSON(VALIDATE_SECURITY_ACTION, answerMap).then(
          ({ errmsg, data }) => {
            if (!errmsg) {
              commit(SET_RESET_QUESSION_TOKEN, data.token);
              resolve(data.token);
            } else {
              // dispatch(SHOW_TIPS_MSG, {
              //   message: errmsg
              // })
              reject(new Error(errmsg));
            }
          }
        );
      });
    },

    [VERIFY_EMAIL]({ state }, params) {
      params.terms = params.terms ? CHECKED_VAL : '';
      params.token = state.emailToken;
      return new Promise((resolve, reject) => {
        getJSON(VERIFY_EMAIL_ACTION, params).then(({ errmsg }) => {
          if (!errmsg) {
            resolve(true);
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    },
    [BIND_EMAIL]({ state, commit }, params) {
      params.terms = params.terms ? CHECKED_VAL : '';
      params.token = state.emailToken;
      var validateres = bindEmailValidate(params);
      return new Promise((resolve, reject) => {
        if (validateres.dirty && !params.rebind) {
          reject(new Error(validateres.errmsg));
        } else {
          params.email = encryption(params.email);
          getJSON(BIND_EMAIL_ACTION, params).then(({ errmsg, data }) => {
            if (!errmsg) {
              commit(RESET_EMAIL, data['EMAIL']);
              commit(CHANGE_IS_BIND_EMAIL, data['IS_BIND_EMAIL']);
              resolve(true);
            } else {
              reject(new Error(errmsg));
            }
          });
        }
      });
    },
    [SEND_VGM_CODE](_, params) {
      return new Promise((resolve, reject) => {
        getJSON(SEND_VGM_CODE_ACTION, {
          phone_code: params.phone_code,
          phone: params.phone ? encryption(params.phone) : ''
        }).then(({ errmsg, data }) => {
          if (!errmsg) {
            resolve(data);
          } else {
            reject(errmsg);
          }
        });
      });
    },
    [SET_USR_EXT_INFO]({ commit, dispatch }, params) {
      // if(postingProfile){
      //     return "";
      // }
      params.terms = params.terms ? CHECKED_VAL : '';
      var validateres = profileValidate(params);
      let postingProfile = true;
      return new Promise((resolve, reject) => {
        if (validateres.dirty) {
          reject(new Error(validateres.errmsg));
          postingProfile = false;
        } else {
          params.real_name = params.real_name
            ? encryption(params.real_name)
            : '';
          params.birthday = params.birthday ? encryption(params.birthday) : '';
          params.phone = params.phone ? encryption(params.phone) : '';
          params.id_card_country = params.id_card_country
            ? encryption(params.id_card_country)
            : '';
          params.id_card_number = params.id_card_number
            ? encryption(params.id_card_number)
            : '';
          params.email = params.email ? encryption(params.email) : '';
          getJSON(SET_EXT_INFO_ACTION, params).then(({ errmsg, data }) => {
            postingProfile = false;
            if (!errmsg) {
              dispatch(TOST, languages.get('submitSuccess'));
              commit(CHANGE_EXTEN_INFO, data);
              resolve(extInfoMap(data));
            } else {
              reject(new Error(errmsg));
            }
          });
        }
      });
    },
    [SET_USR_EXT_INFO_VGM]({ commit, dispatch }, params) {
      params.terms = params.terms ? CHECKED_VAL : '';
      let postingProfile = true;
      return new Promise((resolve, reject) => {
        params.real_name = params.real_name ? encryption(params.real_name) : '';
        params.birthday = params.birthday ? encryption(params.birthday) : '';
        params.phone = params.phone ? encryption(params.phone) : '';
        params.id_card_country = params.id_card_country
          ? encryption(params.id_card_country)
          : '';
        params.id_card_number = params.id_card_number
          ? encryption(params.id_card_number)
          : '';
        params.id_card_issue_region = params.id_card_issue_region
          ? encryption(params.id_card_issue_region)
          : '';
        params.id_card_issue_date = params.id_card_issue_date
          ? encryption(params.id_card_issue_date)
          : '';
        params.email = params.email ? encryption(params.email) : '';
        params.email_not_verify = params.email_not_verify
          ? encryption(params.email_not_verify)
          : '';
        params.address = params.address ? encryption(params.address) : '';
        getJSON(SET_EXT_INFO_ACTION, params).then(({ errmsg, data }) => {
          postingProfile = false;
          if (!errmsg) {
            dispatch(TOST, languages.get('submitSuccess'));
            resolve(extInfoMap(data));
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    },
    [LOAD_EXTEND_INFO]({ commit }, payload) {
      return new Promise(resolve => {
        getJSON(LOAD_EXTEND_INFO_ACTION, { ...payload }).then(
          ({ errmsg, data }) => {
            if (!errmsg) {
              commit(RESET_EMAIL, data['EMAIL']);
              commit(CHANGE_IS_BIND_EMAIL, data.IS_BIND_EMAIL);
              resolve(extInfoMap(data));
            }
          }
        );
      });
    },
    [LOAD_USER_INFO]({ commit, state }, { errmsg }) {
      if (!errmsg) {
        commit(
          SET_ORIGIN_USER_TYPE,
          globalConfig.getHrefParam('originUserType') || '4'
        );
      }
    },
    [SET_ORIGIN_USER_TYPE_ACTION]({ commit, state }, { typeId }) {
      commit(SET_ORIGIN_USER_TYPE, typeId);
    },
    [SET_QUESSION]({ commit, state, dispatch }, payload) {
      let answerMap = mapAnswerKeyToPost(payload.answers);
      var validateres = safeQuessionValite(payload.answers);
      if (state.resetQuessionToken) {
        answerMap['token'] = state.resetQuessionToken;
      }
      return new Promise((resolve, reject) => {
        if (validateres.dirty) {
          reject(new Error(validateres.errmsg));
        } else {
          getJSON(SET_SAFE_QUESSION_ACTION, {
            ...answerMap,
            ...payload.other
          }).then(({ errmsg, data }) => {
            if (!errmsg) {
              dispatch(LOAD_SAFE_QEUSSION, data || {});
              dispatch(TOST, languages.get('submitSuccess'));
              resolve(true);
            } else {
              reject(new Error(errmsg));
            }
          });
        }
      });
    },
    [LOAD_SAFE_QEUSSION]({ commit }, payload) {
      getJSON(LOAD_SAFE_QUESSION_ACTION, { ...payload }).then(
        ({ errmsg, data }) => {
          if (!errmsg) {
            commit(LOAD_SAFE_QEUSSION, data.question_list);
            commit(SET_MY_QUESSION, data.my_question);
          }
        }
      );
    },
    [UPGRADE]({ commit, dispatch }, params) {
      params.terms = params.terms ? CHECKED_VAL : '';
      return new Promise((resolve, reject) => {
        var validateres = upgradeValite(params);
        if (validateres.dirty) {
          reject(new Error(validateres.errmsg));
        } else {
          getJSON(UPGRADE_ACTION, {
            ...params,
            newLoginName: params.accountName,
            loginPwd: encryption(params.password),
            reloginPwd: encryption(params.repassword),
            terms: params.terms,
            password: encodeURIComponent(params.password),
            repassword: encodeURIComponent(params.repassword)
          }).then(({ errmsg, data }) => {
            if (errmsg) {
              reject(new Error(errmsg));
            } else {
              dispatch(TOST, languages.get('submitSuccess'));
              commit(CHANGE_USER_INFO, data);
              resolve(data);
            }
          });
        }
      });
    },
    [GET_VERIFFY_CODE]({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        var rebindEmail = /\*{5}/.test(payload.email);
        var validateres = getVerrifyCodeValidate(payload.email);
        if (validateres.dirty && !rebindEmail) {
          // dispatch(SHOW_TIPS_MSG, {
          //   message: validateres.errmsg
          // })
          reject(new Error(validateres.errmsg));
        } else {
          getJSON(EMAIL_VARRIFY_ACTION, {
            ...payload,
            email: rebindEmail ? '' : encryption(payload.email),
            ref: payload.ref,
            token: state.emailToken
          }).then(({ errmsg, data }) => {
            if (errmsg) {
              // dispatch(SHOW_TIPS_MSG, {
              //   message: errmsg
              // })
              reject(new Error(errmsg));
            } else {
              commit(SET_EMAIL_TOKEN, data.token);
              resolve(data);
            }
          });
        }
      });
    },
    [CHANGE_PWD]({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        params.terms = params.terms ? CHECKED_VAL : '';
        var validateres = changePwdValite(params);
        if (validateres.dirty) {
          // dispatch(SHOW_TIPS_MSG, {
          //   message: validateres.errmsg
          // })
          reject(new Error(validateres.errmsg));
        } else {
          getJSON(CHANGE_PWD_ACTION, {
            ...params,
            password: encryption(params.password),
            newPassword: encryption(params.newPassword),
            reNewPwd: encryption(params.reNewPwd),
            forward: params.forward || '',
            terms: params.terms
          }).then(({ errmsg, data }) => {
            if (errmsg) {
              // dispatch(SHOW_TIPS_MSG, {
              //   message: errmsg
              // })
              reject(new Error(errmsg));
            } else {
              // dispatch(TOST,languages.get("submitSuccess"))
              resolve(true);
            }
          });
        }
      });
    },
    [REFRESH_USER_JSON]({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        getJSON(REFRESH_USER_JSON_ACTION, params || {}).then(({ errmsg }) => {
          if (!errmsg) {
            resolve();
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    }
  }
};
